export default "__VITE_ASSET__05f617e1__"